var variantImageAutomator = function () {
  function create_element_append_to_body(el, elId, display) {
    display || (display = "none");
    var g = document.createElement(el);
    (g.id = elId),
      (g.style = "display:" + display),
      document.body.appendChild(g);
  }
  function find_current_variant(section) {
    var variant_id,
      element = section || document;
    default_variant =
      0 == default_variant ? Object.keys(product_variants)[0] : default_variant;
    var queries = {};
    if (
      (document.location.search
        .substr(1)
        .split("&")
        .forEach(function (q) {
          var i = q.split("=");
          try {
            queries[i[0].toString()] = i[1].toString();
          } catch (err) {}
        }),
      isNaN(queries.variant))
    ) {
      let selector =
        element.querySelector('form[action="/cart/add"] [name="id"]:checked') ||
        element.querySelector('form[action="/cart/add"] [name="id"]') ||
        element.querySelector('select[name="id"]') ||
        element.querySelector('[name="id"]');
      variant_id = selector ? selector.value : default_variant;
    } else
      variant_id = queries.variant
        ? queries.variant
        : element.querySelector(
            "select option[value='" + default_variant + "']"
          ).parentNode.value;
    return variant_id || default_variant;
  }
  function is_variant_in_url() {
    return document.location.search.indexOf("variant=") >= 0;
  }
  function find_current_variant_from_url() {
    var variant_id,
      queries = {};
    return (
      document.location.search
        .substr(1)
        .split("&")
        .forEach(function (q) {
          var i = q.split("=");
          try {
            queries[i[0].toString()] = i[1].toString();
          } catch (err) {}
        }),
      isNaN(queries.variant)
        ? (variant_id = null)
        : queries.variant && (variant_id = queries.variant),
      variant_id
    );
  }
  function find_variant_images(variant_id) {
    var variant_images;
    if (
      (variant_id || (variant_id = find_current_variant()),
      variants.hasOwnProperty(variant_id)
        ? (variant_images = variants[variant_id])
        : ((variant_id = find_current_variant_from_url()),
          (variant_images = variants.hasOwnProperty(variant_id)
            ? variants[variant_id]
            : variants[default_variant])),
      (!variant_images || 0 == variant_images.length) &&
        skip_showcase_image >= product_images.length)
    )
      return product_images;
    if (
      !is_home &&
      "no_action" != only_run_if_variant_in_url &&
      !is_variant_in_url()
    ) {
      function showcase_images() {
        return variants.g.length ? variants.g : variant_assigned_images;
      }
      function skipped_and_showcase_images() {
        let images = variants.skipped.concat(variants.g);
        return images.length ? images : variant_assigned_images;
      }
      if (((selection_vid = 0), "showcase_only" == only_run_if_variant_in_url))
        return showcase_images();
      if ("showcase_and_variants" == only_run_if_variant_in_url)
        return variants.g.concat(variant_assigned_images);
      if ("featured_only" == only_run_if_variant_in_url)
        return [product_images[0]];
      if ("featured_and_showcase" == only_run_if_variant_in_url)
        return skip_showcase_image > 0
          ? [product_images[0]].concat(variants.g)
          : showcase_images();
      if ("skipped_and_showcase" == only_run_if_variant_in_url)
        return skipped_and_showcase_images();
      if ("show_all" == only_run_if_variant_in_url) return product_images;
    }
    return (
      "at_start" == general_images_position
        ? (variant_images = variants.g.concat(variant_images))
        : "at_end" == general_images_position &&
          (variant_images = variant_images.concat(variants.g)),
      variant_images && 0 != variant_images.length
        ? variant_images
        : product_images
    );
  }
  function is_array_equal(a1, a2) {
    return JSON.stringify(a1) === JSON.stringify(a2);
  }
  function find_variant_media(variant_id) {
    var variant_media;
    if (
      (variant_id || (variant_id = find_current_variant()),
      variants_media.hasOwnProperty(variant_id)
        ? (variant_media = variants_media[variant_id])
        : ((variant_id = find_current_variant_from_url()),
          (variant_media = variants_media.hasOwnProperty(variant_id)
            ? variants_media[variant_id]
            : variants_media[default_variant])),
      (!variant_media || 0 == variant_media.length) &&
        skip_showcase_image >= product_media.length)
    )
      return product_media;
    if (
      !is_home &&
      "no_action" != only_run_if_variant_in_url &&
      !is_variant_in_url()
    ) {
      function showcase_images() {
        return variants_media.g.length
          ? variants_media.g
          : variant_assigned_media;
      }
      function skipped_and_showcase_images() {
        let images = variants_media.skipped.concat(variants_media.g);
        return images.length ? images : variant_assigned_media;
      }
      if (((selection_vid = 0), "showcase_only" == only_run_if_variant_in_url))
        return showcase_images();
      if ("showcase_and_variants" == only_run_if_variant_in_url)
        return variants_media.g.concat(variant_assigned_media);
      if ("featured_only" == only_run_if_variant_in_url)
        return [product_media[0]];
      if ("featured_and_showcase" == only_run_if_variant_in_url)
        return skip_showcase_image > 0
          ? [product_media[0]].concat(variants_media.g)
          : showcase_images();
      if ("skipped_and_showcase" == only_run_if_variant_in_url)
        return skipped_and_showcase_images();
      if ("show_all" == only_run_if_variant_in_url) return product_media;
    }
    return (
      "at_start" == general_images_position
        ? (variant_media = variants_media.g.concat(variant_media))
        : "at_end" == general_images_position &&
          (variant_media = variant_media.concat(variants_media.g)),
      variant_media && 0 != variant_media.length
        ? priority_video
          ? moveVideoToFront(variant_media)
          : variant_media
        : product_media
    );
  }
  function moveVideoToFront(arr) {
    const videoIndex = arr.findIndex(
      (obj) => "video" === obj.media_type || "external_video" === obj.media_type
    );
    if (videoIndex > -1) {
      const videoObj = arr.splice(videoIndex, 1)[0];
      arr.unshift(videoObj);
    }
    return arr;
  }
  var quick_view_enabled = !1,
    skip_showcase_image = 0,
    selected_theme_name = "Broadcast",
    priority_video = !1,
    can_execute_script = !1,
    is_home = !1,
    only_run_if_variant_in_url = "no_action",
    limit_on_product = "none",
    product_url = "",
    is_product_preview =
      window.location.href.toLowerCase().indexOf("/products_preview") >= 0,
    is_product_page = /\/products\/|\/produkty\/|\/produkte\//.test(
      window.location.href.toLowerCase()
    ),
    is_pages =
      ((is_home = "/" == window.location.pathname),
      window.location.pathname.indexOf("/pages/") >= 0),
    variant_id = 0,
    selection_vid = 0,
    last_variant_images = {};
  if (
    ((is_home || is_pages || is_product_page || is_product_preview) &&
      (can_execute_script = !0),
    quick_view_enabled)
  )
    var jTimer = setInterval(function () {
      window.$ &&
        window.jQuery &&
        (clearInterval(jTimer), $(".quicklook [data-product-thumbs]").hide());
    }, 10);
  if (can_execute_script) {
    if (is_home) {
      if ("Startup" == selected_theme_name)
        product_url = document.querySelector(
          '[data-section-type="featured-product"] .product-title a'
        )
          ? document.querySelector(
              '[data-section-type="featured-product"] .product-title a'
            ).href
          : "";
      else if ("Flow" == selected_theme_name)
        product_url = document.querySelector(
          "#product-box .product-details--form-wrapper a"
        )
          ? document.querySelector(
              "#product-box .product-details--form-wrapper a"
            ).href
          : "";
      else if ("Debut" == selected_theme_name);
      else if ("Success theme" == selected_theme_name);
      else if ("Supply V2" == selected_theme_name)
        product_url = document.querySelector(
          '[data-section-type="product-template"] a.full-details'
        )
          ? document.querySelector(
              '[data-section-type="product-template"] a.full-details'
            ).href
          : "";
      else if ("Launch" == selected_theme_name)
        product_url = document.querySelector(
          ".home-featured-product .product-title a"
        )
          ? document.querySelector(".home-featured-product .product-title a")
              .href
          : "";
      else if ("Responsive" == selected_theme_name)
        product_url = document.querySelector(
          ".featured-product-section .product_name a"
        )
          ? document.querySelector(".featured-product-section .product_name a")
              .href
          : "";
      else if ("Streamline" == selected_theme_name);
      else if ("Broadcast" == selected_theme_name)
        product_url = document.querySelector(
          '[data-section-type="product"] .product__title a'
        )
          ? document.querySelector(
              '[data-section-type="product"] .product__title a'
            ).href
          : "";
      else if ("Palo Alto V2" == selected_theme_name)
        product_url = document.querySelector(
          '[data-section-type="featured-product"]:first-child .featured-product-title a'
        )
          ? document.querySelector(
              '[data-section-type="featured-product"]:first-child .featured-product-title a'
            ).href
          : "";
      else if ("Startup V3" == selected_theme_name)
        product_url = document.querySelector(".product-title a")
          ? document.querySelector(".product-title a").href
          : "";
      else if (
        [
          "Turbo",
          "Turbo Seoul",
          "Turbo Florence",
          "Turbo Portland",
          "Turbo Chicago",
          "Turbo Dubai",
          "Turbo Tennessee",
        ].indexOf(selected_theme_name) >= 0
      )
        product_url = document.querySelector(".product_section .product_name a")
          ? document.querySelector(".product_section .product_name a").href
          : "";
      else if ("Palo Alto V3" == selected_theme_name)
        product_url = document.querySelector(
          '[data-section-type="featured-product"] .featured-product-title a'
        )
          ? document.querySelector(
              '[data-section-type="featured-product"] .featured-product-title a'
            ).href
          : "";
      else if ("Warehouse" == selected_theme_name)
        product_url = document.querySelector(
          '[data-section-type="product"]:last-child .product-meta__title a'
        )
          ? document.querySelector(
              '[data-section-type="product"]:last-child .product-meta__title a'
            ).href
          : "";
      else if ("Flex" == selected_theme_name)
        product_url = document.querySelector(
          ".shopify-section.featured-product-section.jsProduct .product-thumbnail__title a"
        )
          ? document.querySelector(
              ".shopify-section.featured-product-section.jsProduct .product-thumbnail__title a"
            ).href
          : "";
      else if (
        ["Empire V5.1", "Superstore V2"].indexOf(selected_theme_name) >= 0
      ) {
        let product_links = document.querySelectorAll(
          ".featured-product--container .product-link"
        );
        product_url = product_links.length
          ? product_links[product_links.length - 1].href
          : "";
      }
      product_url = product_url.replace(/\/$/, "").split("?")[0].split("#")[0];
    } else
      is_pages
        ? ("Broadcast" == selected_theme_name &&
            (product_url = document.querySelector(
              '[data-section-type="product"] .product__title a'
            )
              ? document.querySelector(
                  '[data-section-type="product"] .product__title a'
                ).href
              : ""),
          (product_url = product_url
            .replace(/\/$/, "")
            .split("?")[0]
            .split("#")[0]))
        : (product_url = window.location.pathname
            .replace(/\/$/, "")
            .replace("//", "/"));
    if (
      product_url.length &&
      (void 0 === window.via_product_handle ||
        window.via_product_handle != product_url)
    ) {
      var productJson;
      window.via_product_handle = product_url;
      var variants = {},
        product_variants = {};
      (variants.g = []), (variants.skipped = []);
      var product_images = [],
        default_variant = 0,
        general_images_position = "at_end",
        variant_assigned_images = [],
        variants_media = {},
        product_media = [];
      (variants_media.g = []), (variants_media.skipped = []);
      var variant_assigned_media = [],
        product_tags = "",
        variant_assigned_images_ids = [],
        variant_assigned_media_ids = [],
        all_variant_media = [],
        all_variant_images = [];
        var ql_all_variants = [];
        //   产品媒体图
      function assign_variants_media(productJson) {
        (product_media = ql_arr_hb_all_media ? ql_arr_hb_all_media : productJson.media),
        (ql_arr_hb_all_variants ? ql_all_variants = ql_arr_hb_all_variants : ql_all_variants = productJson.variants ),
            ql_all_variants.forEach(function (variant) {
            variant.featured_image &&
              -1 ==
                variant_assigned_images_ids.indexOf(
                  variant.featured_image.id
                ) &&
              (variant_assigned_images_ids.push(variant.featured_image.id),
              variant_assigned_images.push(variant.featured_image)),
              variant.featured_media &&
                -1 ==
                  variant_assigned_media_ids.indexOf(
                    variant.featured_media.id
                  ) &&
                (variant_assigned_media_ids.push(variant.featured_media.id),
                variant_assigned_media.push(variant.featured_media)),
              !default_variant &&
                variant.available &&
                (default_variant = variant.id),
              variant.featured_media &&
                (all_variant_media[variant.featured_media.id] ||
                  (all_variant_media[variant.featured_media.id] = []),
                all_variant_media[variant.featured_media.id].push(variant.id)),
              (variants_media[variant.id] = []),
              variant.featured_image &&
                (all_variant_images[variant.featured_image.id] ||
                  (all_variant_images[variant.featured_image.id] = []),
                all_variant_images[variant.featured_image.id].push(variant.id)),
              (variants[variant.id] = []),
              (product_variants[variant.id] = variant);
          });
        var general_media = !0,
          current_variant_ids = [];
        product_media.forEach(function (media, index) {
          general_media && -1 == variant_assigned_media_ids.indexOf(media.id)
            ? skip_showcase_image > 0 && index < skip_showcase_image
              ? variants_media.skipped.push(media)
              : variants_media.g.push(media)
            : ((general_media = !1),
              (current_variant_ids = all_variant_media[media.id]
                ? all_variant_media[media.id]
                : current_variant_ids).forEach(function (variant_id) {
                variants_media[variant_id].push(media);
              }));
        });
      }
      function assign_variant_images(images) {
        var general_images = !0,
          current_variant_ids = [];
        (product_images = images).forEach(function (image, index) {
          general_images && -1 == variant_assigned_images_ids.indexOf(image.id)
            ? skip_showcase_image > 0 && index < skip_showcase_image
              ? variants.skipped.push(image)
              : variants.g.push(image)
            : ((general_images = !1),
              (current_variant_ids = all_variant_images[image.id]
                ? all_variant_images[image.id]
                : current_variant_ids).forEach(function (variant_id) {
                variants[variant_id].push(image);
              }));
        });
      }
      function is_correct_theme_selected() {
        let excluded_theme_names =
          "Shogun Page Builder App, GemPages Page Builder App, LayoutHub Easy Page Builder App, MagicZoomPlus App, MyCustomTheme, PageFly Advanced Page Builder App";
        if (window.BOOMR && window.BOOMR.themeName) {
          let theme_name = "Broadcast".toLowerCase(),
            boomr_theme = window.BOOMR.themeName.toLowerCase();
          if (excluded_theme_names.includes(theme_name)) return !0;
          if (!theme_name.includes(boomr_theme))
            return (
              console.log(
                `If app is not working, please select ${window.BOOMR.themeName} as theme in app dashboard.`
              ),
              !1
            );
        }
        return !0;
      }
      function is_restrictable() {
        return (
          ("include_selected" == limit_on_product &&
            0 ==
              /via_enabled|viaenabled|via-enabled|__via_enabled/.test(
                product_tags.toLowerCase()
              )) ||
          ("exclude_selected" == limit_on_product &&
            1 ==
              /via_disabled|via-disabled|viadisabled|__via_disabled/.test(
                product_tags.toLowerCase()
              ))
        );
      }
      function get_ready_with_data(_callback) {
        var DONE = 4,
          OK = 200,
          xhr_for_js = new XMLHttpRequest();
        return (
          xhr_for_js.open("GET", product_url + ".js", !0),
          xhr_for_js.send(),
          (xhr_for_js.onreadystatechange = function () {
            if (xhr_for_js.readyState === DONE && xhr_for_js.status === OK) {
              if (
                ((productJson = JSON.parse(xhr_for_js.responseText)),
                (product_tags = productJson.tags.join()),
                (void 0 === productJson.media ||
                  0 == productJson.media.length) &&
                  0 == productJson.images.length)
              )
                return;
              assign_variants_media(productJson);
              var xhr_for_json = new XMLHttpRequest();
              xhr_for_json.open("GET", product_url + ".json", !0),
                xhr_for_json.send(),
                (xhr_for_json.onreadystatechange = function () {
                  xhr_for_json.readyState === DONE &&
                    xhr_for_json.status === OK &&
                    (assign_variant_images(
                      JSON.parse(xhr_for_json.responseText).product.images
                    ),
                    _callback());
                });
            }
          }),
          !0
        );
      }
      function processJSONInformation() {
        (product_tags = productJson.tags.join()),
          assign_variants_media(productJson),
          assign_variant_images(productJson.product_images),
          execute_app_code();
      }
      function run() {
        if (is_product_preview)
          try {
            (productJson = JSON.parse(
              document.querySelector("[sa-product-json]").innerText
            )),
              processJSONInformation();
          } catch (e) {
            setTimeout(function () {
              run();
            }, 100);
          }
        else if (document.querySelector("[sa-product-json]"))
          try {
            (productJson = JSON.parse(
              document.querySelector("[sa-product-json]").innerText
            )).media && processJSONInformation();
          } catch (e) {}
        is_product_preview ||
          (productJson && productJson.media) ||
          get_ready_with_data(execute_app_code);
      }
      function execute_app_code() {
        if (
          !(
            is_restrictable() ||
            (1 == product_media.length && 1 == product_images.length)
          )
        ) {
          is_correct_theme_selected();
          var nTimer = setInterval(function () {
            if (
              "interactive" == document.readyState ||
              "complete" == document.readyState
            ) {
              clearInterval(nTimer);
              const selectors$D = {
                videoPlayer: "[data-video]",
                modelViewer: "[data-model]",
                dataType: "data-type",
                dataMediaId: "data-media-id",
                dataVideoLooping: "data-video-looping",
                dataYoutubeId: "data-youtube-id",
                productMediaWrapper: "[data-product-single-media-wrapper]",
                productMediaContainer: "[data-product-single-media-group]",
                classMediaHidden: "media--hidden",
              };
              class Video {
                constructor(e) {
                  (this.section = e),
                    (this.container = e),
                    (this.id = e.id),
                    (this.players = {}),
                    this.init();
                }
                init() {
                  const e = this.container.querySelectorAll(
                    selectors$D.videoPlayer
                  );
                  let t = !1,
                    s = !1;
                  for (let i = 0; i < e.length; i++) {
                    const o = e[i].getAttribute("id"),
                      r = e[i].getAttribute(selectors$D.dataType),
                      a = e[i].getAttribute(selectors$D.dataMediaId);
                    if (
                      ((this.players[o] = {}),
                      (this.players[o].id = o),
                      (this.players[o].type = r),
                      (this.players[o].mediaId = a),
                      (this.players[o].container = e[i]),
                      (this.players[o].element =
                        e[i].querySelector("iframe, video")),
                      !this.players[o].element)
                    )
                      return;
                    if ("external_video" === r) {
                      const s = e[i].getAttribute(selectors$D.dataYoutubeId);
                      (this.players[o].externalID = s), (t = !0);
                    } else "video" === r && (s = !0);
                  }
                  s &&
                    (window.isPlyrLoaded
                      ? this.nativeInitCallback()
                      : loadScript({ name: "video-ui", version: "1.0" }).then(
                          () => this.nativeInitCallback()
                        )),
                    t &&
                      (window.isYoutubeAPILoaded
                        ? this.youTubeInitCallback()
                        : loadScript({
                            url: "https://www.youtube.com/iframe_api",
                          }).then(() => this.youTubeInitCallback()));
                }
                youTubeInitCallback() {
                  for (const e in this.players)
                    if ("external_video" === this.players[e].type) {
                      const t = this.players[e],
                        s =
                          "true" ===
                          this.players[e].container
                            .closest(`[${selectors$D.dataVideoLooping}]`)
                            .getAttribute(selectors$D.dataVideoLooping),
                        i = {
                          playerVars: {
                            cc_load_policy: 0,
                            iv_load_policy: 3,
                            modestbranding: 1,
                            playsinline: 1,
                            autohide: 0,
                            controls: 1,
                            branding: 0,
                            showinfo: 0,
                            rel: 0,
                            fs: 0,
                            wmode: "opaque",
                          },
                          events: {
                            onStateChange: (e) => {
                              0 === e.data && s && e.target.seekTo(0);
                              const t = e.target
                                .getIframe()
                                .closest(`[${selectors$D.dataMediaId}]`);
                              let i = "";
                              t &&
                                (i = t.getAttribute(selectors$D.dataMediaId)),
                                1 === e.data && this.pauseOtherMedia(i);
                            },
                          },
                        };
                      (i.videoId = t.externalID),
                        YT.ready(() => {
                          (this.players[e].player = new YT.Player(
                            t.element,
                            i
                          )),
                            (window.isYoutubeAPILoaded = !0),
                            this.players[e].container.addEventListener(
                              "mediaHidden",
                              (e) => this.onHidden(e, !0)
                            ),
                            this.players[e].container.addEventListener(
                              "xrLaunch",
                              (e) => this.onHidden(e, !0)
                            ),
                            this.players[e].container.addEventListener(
                              "mediaVisible",
                              (e) => this.onVisible(e, !0)
                            );
                        });
                    }
                }
                nativeInitCallback() {
                  for (const e in this.players)
                    if ("video" === this.players[e].type) {
                      const t = this.players[e],
                        s = {
                          loop: {
                            active:
                              "true" ===
                              this.players[e].container
                                .closest(`[${selectors$D.dataVideoLooping}]`)
                                .getAttribute(selectors$D.dataVideoLooping),
                          },
                          focusOnPlay: !0,
                        };
                      (this.players[e].player = new Shopify.Plyr(t.element, s)),
                        t.element.addEventListener("play", (e) => {
                          const t = e.target.closest(
                            `[${selectors$D.dataMediaId}]`
                          );
                          let s = "";
                          t && (s = t.getAttribute(selectors$D.dataMediaId)),
                            this.pauseOtherMedia(s);
                        }),
                        (window.isPlyrLoaded = !0),
                        this.players[e].container.addEventListener(
                          "mediaHidden",
                          (e) => this.onHidden(e, !1)
                        ),
                        this.players[e].container.addEventListener(
                          "xrLaunch",
                          (e) => this.onHidden(e, !1)
                        ),
                        this.players[e].container.addEventListener(
                          "mediaVisible",
                          (e) => this.onVisible(e, !1)
                        );
                    }
                }
                onHidden(e, t = !1) {
                  if (void 0 !== e.target.dataset.playerId) {
                    const s = e.target.dataset.playerId,
                      i = this.players[s];
                    !0 === t && i.player && i.player.pauseVideo
                      ? i.player.pauseVideo()
                      : i.player && i.player.pause && i.player.pause();
                  }
                }
                onVisible(e, t = !1) {
                  if (
                    !window.theme.touched &&
                    void 0 !== e.target.dataset.playerId
                  ) {
                    const s = e.target.dataset.playerId,
                      i = this.players[s];
                    !0 === t && i.player && i.player.playVideo
                      ? i.player.playVideo()
                      : i.player && i.player.play && i.player.play();
                  }
                }
                pauseOtherMedia(e) {
                  const t = `[${selectors$D.dataMediaId}="${e}"]`,
                    s = document.querySelector(
                      `${selectors$D.productMediaWrapper}${t}`
                    ),
                    i = document.querySelectorAll(
                      `${selectors$D.productMediaWrapper}:not(${t})`
                    );
                  s.classList.remove(selectors$D.classMediaHidden),
                    i.length &&
                      i.forEach((e) => {
                        e.dispatchEvent(new CustomEvent("mediaHidden")),
                          e.classList.add(selectors$D.classMediaHidden);
                      });
                }
              }
              var hosts = { html5: "html5", youtube: "youtube" },
                selectors$B = {
                  deferredMedia: "[data-deferred-media]",
                  deferredMediaButton: "[data-deferred-media-button]",
                  productMediaWrapper: "[data-product-single-media-wrapper]",
                  productMediaSlider: "[data-product-single-media-slider]",
                  mediaContainer: "[data-video]",
                  mediaId: "data-media-id",
                },
                classes$m = { mediaHidden: "media--hidden" };
              class Video2 {
                constructor(e) {
                  (this.section = e),
                    (this.container = e),
                    (this.id = e.id),
                    (this.players = {}),
                    this.init();
                }
                init() {
                  this.container
                    .querySelectorAll(selectors$B.mediaContainer)
                    .forEach((e) => {
                      const t = e.querySelector(
                        selectors$B.deferredMediaButton
                      );
                      t &&
                        t.addEventListener(
                          "click",
                          this.loadContent.bind(this, e)
                        );
                    });
                }
                loadContent(e) {
                  if (
                    e
                      .querySelector(selectors$B.deferredMedia)
                      .getAttribute("loaded")
                  )
                    return;
                  const t = document.createElement("div");
                  t.appendChild(
                    e
                      .querySelector("template")
                      .content.firstElementChild.cloneNode(!0)
                  );
                  const s = e.dataset.mediaId,
                    i = t.querySelector("video, iframe"),
                    o = this.hostFromVideoElement(i),
                    r = e.querySelector(selectors$B.deferredMedia);
                  r.appendChild(i).focus(),
                    r.setAttribute("loaded", !0),
                    (this.players[s] = {
                      mediaId: s,
                      sectionId: this.id,
                      container: e,
                      element: i,
                      host: o,
                      ready: () => {
                        this.createPlayer(s);
                      },
                    });
                  const a = this.players[s];
                  switch (a.host) {
                    case hosts.html5:
                      this.loadVideo(a, hosts.html5);
                      break;
                    case hosts.youtube:
                      window.isYoutubeAPILoaded
                        ? this.loadVideo(a, hosts.youtube)
                        : loadScript({
                            url: "https://www.youtube.com/iframe_api",
                          }).then(() => this.loadVideo(a, hosts.youtube));
                  }
                }
                hostFromVideoElement(e) {
                  return "VIDEO" === e.tagName
                    ? hosts.html5
                    : "IFRAME" === e.tagName &&
                      /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                        e.src
                      )
                    ? hosts.youtube
                    : null;
                }
                loadVideo(e, t) {
                  e.host === t && e.ready();
                }
                createPlayer(e) {
                  const t = this.players[e],
                    s = t.container.dataset.enableVideoLooping;
                  switch (t.host) {
                    case hosts.html5:
                      t.element.addEventListener("play", () => {
                        this.pauseOtherMedia(e);
                      }),
                        t.element.play(),
                        t.container.addEventListener("mediaHidden", (e) =>
                          this.onHidden(e)
                        ),
                        t.container.addEventListener("xrLaunch", (e) =>
                          this.onHidden(e)
                        ),
                        t.container.addEventListener("mediaVisible", (e) =>
                          this.onVisible(e)
                        );
                      break;
                    case hosts.youtube:
                      if (t.host == hosts.youtube && t.player) return;
                      YT.ready(() => {
                        const i = t.container.dataset.videoId;
                        (this.players[e].player = new YT.Player(t.element, {
                          videoId: i,
                          events: {
                            onReady: (e) => {
                              e.target.playVideo();
                            },
                            onStateChange: (t) => {
                              0 === t.data && s && t.target.seekTo(0),
                                1 === t.data && this.pauseOtherMedia(e),
                                t.data;
                            },
                          },
                        })),
                          (window.isYoutubeAPILoaded = !0),
                          t.container.addEventListener("mediaHidden", (e) =>
                            this.onHidden(e)
                          ),
                          t.container.addEventListener("xrLaunch", (e) =>
                            this.onHidden(e)
                          ),
                          t.container.addEventListener("mediaVisible", (e) =>
                            this.onVisible(e)
                          );
                      });
                  }
                }
                onHidden(e) {
                  if (void 0 !== e.target.dataset.mediaId) {
                    const t = e.target.dataset.mediaId,
                      s = this.players[t];
                    s.player && s.player.pauseVideo
                      ? s.player.pauseVideo()
                      : s.element && s.element.pause && s.element.pause();
                  }
                }
                onVisible(e) {
                  if (void 0 !== e.target.dataset.mediaId) {
                    const t = e.target.dataset.mediaId,
                      s = this.players[t];
                    s.player && s.player.playVideo
                      ? s.player.playVideo()
                      : s.element && s.element.play && s.element.play();
                  }
                }
                pauseOtherMedia(e) {
                  const t = `[${selectors$B.mediaId}="${e}"]`,
                    s = document.querySelector(
                      `${selectors$B.productMediaWrapper}${t}`
                    ),
                    i = document.querySelectorAll(
                      `${selectors$B.productMediaWrapper}:not(${t})`
                    );
                  s.classList.remove(classes$m.mediaHidden),
                    i.length &&
                      i.forEach((e) => {
                        e.dispatchEvent(new CustomEvent("mediaHidden")),
                          e.classList.add(classes$m.mediaHidden);
                      });
                }
              }
              var media_used,
                Flickity,
                FlickityFade,
                section = document.querySelector(
                  '[data-section-type="product"]'
                ),
                is_tall_layout = (section.getAttribute("data-section-id"), !1);
              create_element_append_to_body("div", "multi-variant-info"),
                (document.getElementById("multi-variant-info").innerHTML =
                  section.querySelector("[data-product-slideshow]").innerHTML),
                document
                  .querySelectorAll("#multi-variant-info img.lazyloading")
                  .forEach((image) => {
                    image.classList.remove("lazyloading"),
                      image.classList.add("lazyload");
                  });
              var zTimer = setInterval(function () {
                if (
                  "object" == typeof themeVendor &&
                  "function" == typeof themeVendor.Flickity
                ) {
                  clearInterval(zTimer),
                    (Flickity = themeVendor.Flickity),
                    (FlickityFade = themeVendor.FlickityFade);
                  var selectors = document.querySelectorAll(
                    'select, .panda-swatch, .single-option-selector, label, .swatches .swatch-selector, .swatch .swatch-element, form[action="/cart/add"], [data-popout-list], .swatch__button, .selector-wrapper .select-popout__option, [data-product-form] select'
                  );
                  function variant_change_event() {
                    setTimeout(function () {
                      (variant_id = find_current_variant()),
                        selection_vid != variant_id &&
                          (broadcast2_change_images(variant_id),
                          (selection_vid = variant_id));
                    }, 100);
                  }
                  selectors &&
                    Object.entries(selectors).forEach(([index, selector]) => {
                      selector.addEventListener(
                        "click",
                        variant_change_event,
                        !1
                      ),
                        selector.addEventListener(
                          "change",
                          variant_change_event,
                          !1
                        );
                    }),
                    broadcast2_change_images();
                } else
                  "undefined" != typeof $ &&
                    "function" == typeof $.fn.slick &&
                    (clearInterval(zTimer),
                    (is_tall_layout = $('[data-section-type="product"]').data(
                      "tall-layout"
                    )),
                    (section = $(section)).off("variantImageChange.product"),
                    (media_used =
                      $(
                        "[data-product-slideshow] [data-product-single-media-wrapper]"
                      ).length > 0),
                    $("body").on(
                      "change click",
                      "select, label, .single-option-selector, .swatches .swatch-selector, .product__selectors input",
                      function () {
                        setTimeout(function () {
                          (variant_id = find_current_variant()),
                            selection_vid != variant_id &&
                              (broadcast_change_images(variant_id),
                              (selection_vid = variant_id));
                        }, 100);
                      }
                    ),
                    broadcast_change_images());
              }, 20);
              function broadcast2_change_images(variant_id) {
                function createSlider() {
                  if (!slideshow) return;
                  const t = slideshow.querySelectorAll(
                    `[${selectors$a.dataType}]`
                  )[0];
                  if (
                    ((flkty = new FlickityFade(slideshow, {
                      autoPlay: !1,
                      prevNextButtons: !1,
                      contain: !0,
                      pageDots: !1,
                      adaptiveHeight: !0,
                      wrapAround: !0,
                      fade: !0,
                      on: {
                        ready: function () {
                          sliderThumbs(this);
                        },
                      },
                    })).resize(),
                    t)
                  ) {
                    const e = t.getAttribute(selectors$a.dataType);
                    ("model" !== e &&
                      "video" !== e &&
                      "external_video" !== e) ||
                      ((flkty.options.draggable = !1), flkty.updateDraggable());
                  }
                  flkty.on("change", function (t) {
                    let s = t;
                    if (thumbs) {
                      const i = thumbs.querySelector(
                          `.${selectors$a.classSelected}`
                        ),
                        o = thumbs.querySelector(
                          `.thumb [${selectors$a.dataThumbIndex}="${t}"]`
                        );
                      i &&
                        ((s = Array.from(i.parentElement.children).indexOf(i)),
                        i.classList.remove(selectors$a.classSelected)),
                        o &&
                          o.parentElement.classList.add(
                            selectors$a.classSelected
                          );
                    }
                    const i = this.cells[s].element,
                      o = this.selectedElement;
                    i.dispatchEvent(new CustomEvent("mediaHidden")),
                      o.classList.remove(selectors$a.classMediaHidden);
                  }),
                    flkty.on("settle", function () {
                      const s = this.selectedElement,
                        i = Array.prototype.filter.call(
                          s.parentNode.children,
                          function (e) {
                            return e !== s;
                          }
                        ),
                        o = s.getAttribute(selectors$a.dataType),
                        r = document.body.classList.contains(
                          selectors$a.focusEnabled
                        );
                      "model" === o || "video" === o || "external_video" === o
                        ? ((flkty.options.draggable = !1),
                          flkty.updateDraggable())
                        : ((flkty.options.draggable = !0),
                          flkty.updateDraggable()),
                        r && s.dispatchEvent(new Event("focus")),
                        i.length &&
                          i.forEach((e) => {
                            e.classList.add(selectors$a.classMediaHidden);
                          }),
                        s.dispatchEvent(new CustomEvent("mediaVisible"));
                    });
                }
                function sliderThumbs(thisEl) {
                  const slides = thisEl.slides;
                  if (thumbs && slides.length) {
                    let slidesHtml = "";
                    slides.forEach((element, i) => {
                      const slide = element.cells[0].element,
                        type = slide.getAttribute(selectors$w.mediaType),
                        mediaId = slide.getAttribute(selectors$w.dataMediaId),
                        thumb = slide.getAttribute(selectors$w.dataThumb),
                        focusedElement = slide.querySelector(
                          `button, ${selectors$w.focusedElement}`
                        );
                      let thumbAlt = "";
                      const thumbIcon = thumbIcons[type]
                        ? thumbIcons[type]
                        : "";
                      let selected = "",
                        ariaCurrent = !1;
                      slide.querySelector(`[${selectors$w.ariaLabel}]`) &&
                        (thumbAlt = slide
                          .querySelector(`[${selectors$w.ariaLabel}]`)
                          .getAttribute(selectors$w.ariaLabel)),
                        "" === thumbAlt &&
                          slide.hasAttribute(selectors$w.ariaLabel) &&
                          (thumbAlt = slide.getAttribute(
                            selectors$w.ariaLabel
                          )),
                        slide.setAttribute("tabindex", "-1"),
                        focusedElement &&
                          focusedElement.setAttribute("tabindex", "-1"),
                        (slide.classList.contains(classes$p.active) ||
                          0 === i) &&
                          ((selected = classes$p.active), (ariaCurrent = !0)),
                        (slidesHtml += `<div class="product__thumb thumb ${selected}" data-thumb-item><a href="${thumb}" class="product__thumb__link product__thumb__link--${type} thumb__link thumb__link--${type} js-product-slide-thumb" data-thumb-index="${i}" data-thumbnail data-media-id="${mediaId}" aria-label="${thumbAlt}" aria-current="${ariaCurrent}"><img class="thumb__link__image product__thumb__link__image lazyload" loading="lazy" src="${thumb}" sizes="75px" alt="${thumbAlt}">${thumbIcon}</a></div>`);
                    }),
                      "" !== slidesHtml &&
                        ((slidesHtml = `<div class="product__thumbs__holder thumbs-holder" data-thumbs-slider>${slidesHtml}</div>`),
                        (thumbs.innerHTML = slidesHtml));
                  }
                  const productThumbImages = container.querySelectorAll(
                    selectors$w.dataThumbnail
                  );
                  productThumbImages.length &&
                    productThumbImages.forEach((element) => {
                      element.addEventListener("click", function (e) {
                        e.preventDefault();
                        let o = parseInt(
                          this.getAttribute(selectors$a.dataThumbIndex)
                        );
                        flkty.select(o);
                      }),
                        element.addEventListener("keyup", function (e) {
                          if (e.keyCode === window.theme.keyboardKeys.ENTER) {
                            const mediaId = this.getAttribute(
                                selectors$w.dataMediaId
                              ),
                              mediaElem = thisEl.element
                                .querySelector(
                                  `[${selectors$w.dataMediaId}="${mediaId}"]`
                                )
                                .querySelectorAll(
                                  'model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])'
                                )[0];
                            mediaElem &&
                              (mediaElem.dispatchEvent(new Event("focus")),
                              mediaElem.dispatchEvent(new Event("select")));
                          }
                        });
                    });
                }
                function initSliderMobile() {
                  (window.innerWidth ||
                    document.documentElement.clientWidth ||
                    document.body.clientWidth) <
                    (theme.sizes.small || theme.variables.mediaQuerySmall) &&
                    createSlider();
                }
                function createZoom(e) {
                  let s = [],
                    i = 0,
                    o = "";
                  zoomWrappers.forEach((r) => {
                    const n = r.getAttribute(selectors$b.dataImageSrc),
                      a = parseInt(r.getAttribute(selectors$b.dataImageWidth)),
                      l = parseInt(r.getAttribute(selectors$b.dataImageHeight));
                    if (
                      (s.push({ src: n, w: a, h: l, msrc: n }),
                      (o += `<a href="#" class="${classes$2.popupThumb}" style="background-image: url('${n}')"></a>`),
                      (i += 1),
                      zoomWrappers.length === i)
                    ) {
                      let r = `${classes$2.popupClass}`;
                      1 === i &&
                        (r = `${classes$2.popupClass} ${classes$2.popupClassNoThumbs}`),
                        openPhotoSwipe(s, {
                          history: !1,
                          focus: !1,
                          index: e,
                          mainClass: r,
                          showHideOpacity: !0,
                          howAnimationDuration: 150,
                          hideAnimationDuration: 250,
                          closeOnScroll: !1,
                          closeOnVerticalDrag: !1,
                          captionEl: !0,
                          closeEl: !0,
                          closeElClasses: ["caption-close"],
                          tapToClose: !1,
                          clickToCloseNonZoomable: !1,
                          maxSpreadZoom: 2,
                          loop: !0,
                          spacing: 0,
                          allowPanToNext: !0,
                          pinchToClose: !1,
                          addCaptionHTMLFn: function (e, s, i) {
                            zoomCaption(e, s, i);
                          },
                          getThumbBoundsFn: function () {
                            const s = zoomWrappers[e],
                              i =
                                window.pageYOffset ||
                                document.documentElement.scrollTop,
                              o = s.getBoundingClientRect();
                            return { x: o.left, y: o.top + i, w: o.width };
                          },
                        }),
                        thumbsContainer &&
                          "" !== o &&
                          (thumbsContainer.innerHTML = o);
                    }
                  });
                }
                function zoomCaption(e, t) {
                  let i = "";
                  const o = t.children[0];
                  return (
                    zoomCaptionElem &&
                      ((i = zoomCaptionElem.innerHTML),
                      zoomCaptionElem.closest(`.${classes$2.variantSoldOut}`)
                        ? o.classList.add(classes$2.variantSoldOut)
                        : o.classList.remove(classes$2.variantSoldOut),
                      zoomCaptionElem.closest(
                        `.${classes$2.variantUnavailable}`
                      )
                        ? o.classList.add(classes$2.variantUnavailable)
                        : o.classList.remove(classes$2.variantUnavailable)),
                    (o.innerHTML = i),
                    !1
                  );
                }
                function openPhotoSwipe(e, t = "") {
                  const s = document.querySelectorAll(
                    selectors.popupContainer
                  )[0];
                  if (
                    (s.classList.add(classes.classCustomOpen),
                    s.classList.contains(classes.classCustomLoader) &&
                      "" !== t &&
                      t.mainClass)
                  ) {
                    s.setAttribute(selectors.dataOptionClasses, t.mainClass);
                    let e = document.createElement("div");
                    (e.innerHTML = loaderHTML),
                      (e = e.firstChild),
                      s.appendChild(e);
                  } else s.setAttribute(selectors.dataOptionClasses, "");
                  return loadScript({ url: window.theme.assets.photoswipe })
                    .then(() => {
                      const i = window.themePhotoswipe.PhotoSwipe.default,
                        o = window.themePhotoswipe.PhotoSwipeUI.default,
                        r = s.querySelector(selectors.popupThumbs);
                      s.classList.contains(classes.classCustomLoader) &&
                        s.classList.remove(classes.classCustomLoader),
                        s.classList.remove(classes.classCustomOpen);
                      let n = { history: !1, focus: !1, mainClass: "" };
                      "" !== t && (n = t);
                      const a = new i(s, o, e, n);
                      a.init();
                      const l = s.querySelector(selectors.popupCustomIframe);
                      if (l) {
                        const e = l.getAttribute(selectors.dataVideoType),
                          t = l.getAttribute(selectors.dataVideoId),
                          s =
                            "true" ===
                            l.getAttribute(selectors.dataDisableSound),
                          i = l.id;
                        "youtube" == e
                          ? window.isYoutubeAPILoaded
                            ? loadVideoYT(i, t, s)
                            : (window.loadYoutubeAPI(),
                              document.body.addEventListener(
                                "youtubeAPIReady",
                                () => loadVideoYT(i, t, s)
                              ))
                          : "vimeo" == e && loadVideoVimeo(t, l, s);
                      }
                      const c = s.querySelector(selectors.popupCloseBtn);
                      if (
                        (c &&
                          c.addEventListener("click", function () {
                            a.close();
                          }),
                        a.listen("close", function () {
                          const e = s.querySelector(selectors.popupIframe);
                          if (
                            (e &&
                              (e.setAttribute("src", ""),
                              e.parentNode.removeChild(e)),
                            r && r.firstChild)
                          )
                            for (; r.firstChild; ) r.removeChild(r.firstChild);
                          s.setAttribute(selectors.dataOptionClasses, "");
                          const t = s.querySelector(`.${classes.classLoader}`);
                          t && s.removeChild(t);
                        }),
                        r && r.firstChild)
                      ) {
                        const e = (e) => {
                          e.stopPropagation();
                        };
                        r.addEventListener("wheel", e),
                          r.addEventListener("mousewheel", e),
                          r.addEventListener("DOMMouseScroll", e);
                        const t = s.querySelectorAll(
                          `${selectors.popupThumbs} > *`
                        );
                        t.forEach((e, t) => {
                          e.addEventListener("click", function (e) {
                            e.preventDefault(),
                              this.parentElement
                                .querySelector(`.${classes.classCurrent}`)
                                .classList.remove(classes.classCurrent),
                              this.classList.add(classes.classCurrent),
                              a.goTo(t);
                          });
                        });
                        const i = () => {
                          const e = s.querySelector(
                            `${selectors.popupThumbs} > .${classes.classCurrent}`
                          );
                          e && e.classList.remove(classes.classCurrent);
                          const i = t[a.getCurrentIndex()],
                            o = r.scrollLeft + r.offsetWidth,
                            n = i.offsetLeft,
                            l = n + i.offsetWidth;
                          if (
                            (i.classList.add(classes.classCurrent),
                            o <= l || o > n)
                          ) {
                            const e = parseInt(
                              window.getComputedStyle(i).marginLeft
                            );
                            r.scrollTo({
                              top: 0,
                              left: n - e,
                              behavior: "smooth",
                            });
                          }
                        };
                        a.listen("imageLoadComplete", i),
                          a.listen("beforeChange", i);
                      }
                    })
                    .catch((e) => console.error(e));
                }
                function getScript(e, t, s) {
                  let i = document.getElementsByTagName("head")[0],
                    o = !1,
                    r = document.createElement("script");
                  (r.src = e),
                    (r.onload = r.onreadystatechange =
                      function () {
                        o ||
                        (this.readyState &&
                          "loaded" != this.readyState &&
                          "complete" != this.readyState)
                          ? s()
                          : ((o = !0), t());
                      }),
                    i.appendChild(r);
                }
                function loadScript(e = {}) {
                  if ((e.type || (e.type = "json"), e.url))
                    return loaders[e.url]
                      ? loaders[e.url]
                      : getScriptWithPromise(e.url, e.type);
                  if (e.json)
                    return loaders[e.json]
                      ? Promise.resolve(loaders[e.json])
                      : window
                          .fetch(e.json)
                          .then((e) => e.json())
                          .then((t) => ((loaders[e.json] = t), t));
                  if (e.name) {
                    const t = "".concat(e.name, e.version);
                    return loaders[t] ? loaders[t] : loadShopifyWithPromise(e);
                  }
                  return Promise.reject();
                }
                function getScriptWithPromise(e, t) {
                  const s = new Promise((s, i) => {
                    "text" === t
                      ? fetch(e)
                          .then((e) => e.text())
                          .then((e) => {
                            s(e);
                          })
                          .catch((e) => {
                            i(e);
                          })
                      : getScript(
                          e,
                          function () {
                            s();
                          },
                          function () {
                            i();
                          }
                        );
                  });
                  return (loaders[e] = s), s;
                }
                if (
                  ((variant_images = find_variant_media(variant_id)),
                  is_array_equal(last_variant_images, variant_images))
                )
                  return;
                last_variant_images = variant_images;
                var slide_images = "";
                if (
                  (variant_images.forEach((image) => {
                    let main = document.querySelector(
                      "#multi-variant-info .product__slide[data-media-id$='" +
                        image.id +
                        "']"
                    );
                    main &&
                      (main.classList.remove("is-selected"),
                      main.removeAttribute("style"),
                      "video" == image.media_type
                        ? main.querySelector(".video__contain") &&
                          (main.querySelector(".video__contain").innerHTML =
                            main.querySelector("video").outerHTML)
                        : "external_video" == image.media_type &&
                          (main.querySelector("iframe")?.removeAttribute("id"),
                          main.querySelector(".video__contain") &&
                            (main.querySelector(".video__contain").innerHTML =
                              main.querySelector("iframe").outerHTML)),
                      (slide_images += main.outerHTML));
                  }),
                  !slide_images)
                )
                  return;
                Flickity.data("[data-product-slideshow]") &&
                  Flickity.data("[data-product-slideshow]").destroy(),
                  FlickityFade.data("[data-product-slideshow]") &&
                    FlickityFade.data("[data-product-slideshow]").destroy(),
                  section
                    .querySelector("[data-product-slideshow]")
                    .classList.remove("flickity-enabled", "is-draggable"),
                  (section.querySelector("[data-product-slideshow]").innerHTML =
                    slide_images),
                  section.querySelector("[data-product-thumbs]") &&
                    (section.querySelector("[data-product-thumbs]").innerHTML =
                      "");
                var selectors$a = {
                    productSlideshow: "[data-product-slideshow]",
                    productThumbs: "[data-product-thumbs]",
                    dataTallLayout: "data-tall-layout",
                    dataType: "data-type",
                    dataMediaId: "data-media-id",
                    dataThumb: "data-thumb",
                    dataThumbIndex: "data-thumb-index",
                    ariaLabel: "aria-label",
                    dataThumbnail: "[data-thumbnail]",
                    productSlideThumb: ".js-product-slide-thumb",
                    classSelected: "is-active",
                    classMediaHidden: "media--hidden",
                    sliderEnabled: "flickity-enabled",
                    focusEnabled: "focus-enabled",
                    mobileThumbsSliderEnable: "data-mobile-thumbs-slider",
                    thumbsSlider: "[data-thumbs-slider]",
                    modelViewer: "[data-model]",
                  },
                  selectors$w = selectors$a,
                  classes$p = {
                    btn: "btn",
                    active: "is-active",
                    focused: "is-focused",
                    dragging: "is-dragging",
                    selected: "is-selected",
                    sliderEnabled: "flickity-enabled",
                    mediaHidden: "media--hidden",
                  },
                  thumbIcons = {
                    model:
                      '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-model" viewBox="0 0 26 26"><path d="M1 25h24V1H1z"/><path class="icon-media-model-outline" d="M.5 25v.5h25V.5H.5z" fill="none"/><path class="icon-media-model-element" d="M19.13 8.28L14 5.32a2 2 0 0 0-2 0l-5.12 3a2 2 0 0 0-1 1.76V16a2 2 0 0 0 1 1.76l5.12 3a2 2 0 0 0 2 0l5.12-3a2 2 0 0 0 1-1.76v-6a2 2 0 0 0-.99-1.72zm-6.4 11.1l-5.12-3a.53.53 0 0 1-.26-.38v-6a.53.53 0 0 1 .27-.46l5.12-3a.53.53 0 0 1 .53 0l5.12 3-4.72 2.68a1.33 1.33 0 0 0-.67 1.2v6a.53.53 0 0 1-.26 0z" opacity=".6" style="isolation:isolate"/></svg>',
                    video:
                      '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>',
                  },
                  container = section,
                  tallLayout = (is_tall_layout =
                    "true" ===
                    container.getAttribute(selectors$a.dataTallLayout)),
                  slideshow =
                    (container.getAttribute(
                      selectors$a.mobileThumbsSliderEnable
                    ),
                    container.querySelector(selectors$a.productSlideshow)),
                  thumbs = container.querySelector(selectors$a.productThumbs),
                  flkty = null;
                const selectors$b = {
                    zoomWrapper: "[data-zoom-wrapper]",
                    dataImageSrc: "data-image-src",
                    dataImageWidth: "data-image-width",
                    dataImageHeight: "data-image-height",
                    dataImageZoomEnable: "data-image-zoom-enable",
                    thumbs: ".pswp__thumbs",
                    caption: "[data-zoom-caption]",
                  },
                  classes$2 = {
                    variantSoldOut: "variant--soldout",
                    variantUnavailable: "variant--unavailabe",
                    popupThumb: "pswp__thumb",
                    popupClass: "pswp-zoom-gallery",
                    popupClassNoThumbs: "pswp-zoom-gallery--single",
                  },
                  selectors = {
                    popupContainer: ".pswp",
                    popupCloseBtn: ".pswp__custom-close",
                    popupIframe: "iframe",
                    popupCustomIframe: ".pswp__custom-iframe",
                    popupThumbs: ".pswp__thumbs",
                    dataOptionClasses: "data-pswp-option-classes",
                    dataVideoType: "data-video-type",
                    dataDisableSound: "data-disable-sound",
                    dataVideoId: "data-video-id",
                  },
                  classes = {
                    classCurrent: "is-current",
                    classCustomLoader: "pswp--custom-loader",
                    classCustomOpen: "pswp--custom-opening",
                    classLoader: "pswp__loader",
                    loaded: "loaded",
                  },
                  loaderHTML = `<div class="${classes.classLoader}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
                var zoomWrappers = container.querySelectorAll(
                    selectors$b.zoomWrapper
                  ),
                  thumbsContainer = document.querySelector(selectors$b.thumbs),
                  zoomCaptionElem = container.querySelector(
                    selectors$b.caption
                  );
                container.getAttribute(selectors$b.dataImageZoomEnable);
                zoomWrappers.length &&
                  zoomWrappers.forEach((t, s) => {
                    t.addEventListener("click", function (t) {
                      t.preventDefault(), createZoom(s);
                    }),
                      t.addEventListener("keyup", function (t) {
                        13 === t.keyCode && (t.preventDefault(), createZoom(s));
                      });
                  });
                const loaders = {};
                tallLayout ? initSliderMobile() : createSlider(),
                  section.querySelector(".video__contain")
                    ? new Video(section)
                    : new Video2(section);
                var modelViewerElements = section.querySelectorAll(
                  selectors$a.modelViewer
                );
                modelViewerElements.length &&
                  modelViewerElements.forEach((element) => {
                    theme.ProductModel.init(element, this.id);
                  });
              }
              function broadcast_change_images(variant_id) {
                if (
                  ((variant_images = media_used
                    ? find_variant_media(variant_id)
                    : find_variant_images(variant_id)),
                  !is_array_equal(last_variant_images, variant_images))
                ) {
                  last_variant_images = variant_images;
                  var thumb_images = "";
                  $.each(variant_images, function (index, image) {
                    if (media_used) {
                      var obj = $(
                        "#multi-variant-info [data-product-single-media-wrapper][data-media-id$='" +
                          image.id +
                          "']"
                      );
                      "video" == obj.attr("data-type") &&
                        obj.find(".video__contain").html(obj.find("video")),
                        (thumb_images += obj
                          .clone()
                          .wrap("<div></div>")
                          .parent()
                          .html());
                    } else
                      thumb_images += $(
                        "#multi-variant-info [data-product-image][data-image-id='" +
                          image.id +
                          "']"
                      )
                        .closest(".product__photo")
                        .clone()
                        .wrap("<div></div>")
                        .parent()
                        .html();
                  });
                  try {
                    $("[data-product-slideshow]").slick("unslick");
                  } catch (e) {}
                  if (
                    ($("[data-product-slideshow]").html(thumb_images),
                    $("[data-product-thumbs]").html(""),
                    $(window).width() < 750 || !is_tall_layout)
                  )
                    if (media_used) {
                      var thumbIcons = {
                        model:
                          '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-model" viewBox="0 0 26 26"><path d="M1 25h24V1H1z"/><path class="icon-media-model-outline" d="M.5 25v.5h25V.5H.5z" fill="none"/><path class="icon-media-model-element" d="M19.13 8.28L14 5.32a2 2 0 0 0-2 0l-5.12 3a2 2 0 0 0-1 1.76V16a2 2 0 0 0 1 1.76l5.12 3a2 2 0 0 0 2 0l5.12-3a2 2 0 0 0 1-1.76v-6a2 2 0 0 0-.99-1.72zm-6.4 11.1l-5.12-3a.53.53 0 0 1-.26-.38v-6a.53.53 0 0 1 .27-.46l5.12-3a.53.53 0 0 1 .53 0l5.12 3-4.72 2.68a1.33 1.33 0 0 0-.67 1.2v6a.53.53 0 0 1-.26 0z" opacity=".6" style="isolation:isolate"/></svg>',
                        video:
                          '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>',
                      };
                      $("[data-product-slideshow]").slick({
                        accessibility: !1,
                        focusOnSelect: !1,
                        adaptiveHeight: !0,
                        dots: !0,
                        arrows: !1,
                        fade: !0,
                        swipe: !0,
                        appendDots: $("[data-product-thumbs]"),
                        customPaging: function (slider, i) {
                          var type = $(slider.$slides[i]).data("type"),
                            mediaId = $(slider.$slides[i]).data("media-id"),
                            thumb = $(slider.$slides[i]).data("thumb"),
                            thumbAlt = $(slider.$slides[i])
                              .find("[aria-label]")
                              .attr("aria-label"),
                            thumbIcon = thumbIcons[type]
                              ? thumbIcons[type]
                              : "";
                          return (
                            void 0 === thumbAlt &&
                              (thumbAlt = $(slider.$slides[i]).attr(
                                "aria-label"
                              )),
                            '<a href="' +
                              thumb +
                              '" class="thumb--' +
                              type +
                              '" data-thumbnail data-media-id="' +
                              mediaId +
                              '"><img alt="' +
                              thumbAlt +
                              '" src="' +
                              thumb +
                              '">' +
                              thumbIcon +
                              "</a>"
                          );
                        },
                      });
                    } else
                      $("[data-product-slideshow]").slick({
                        adaptiveHeight: !0,
                        dots: !0,
                        arrows: !1,
                        fade: !0,
                        swipe: !0,
                        appendDots: $("[data-product-thumbs]"),
                        customPaging: function (slider, i) {
                          return (
                            '<img src="' +
                            $(slider.$slides[i]).data("thumb") +
                            '">'
                          );
                        },
                      });
                  $("[data-product-slideshow] [data-zoom-wrapper]")
                    .off("click")
                    .one("click", function () {
                      var $this = $(this);
                      $this.zoom({
                        on: "click",
                        touch: "false",
                        callback: function () {
                          $this.click();
                        },
                        onZoomIn: function () {
                          $this.addClass("zoom--active");
                        },
                        onZoomOut: function () {
                          $this.removeClass("zoom--active");
                        },
                      });
                    }),
                    $("[data-product-thumbs]", section).find(".slick-dots")
                      .length > 1 &&
                      $(
                        "[data-product-thumbs] .slick-dots:not(:first)",
                        section
                      ).remove();
                }
              }
            }
          }, 10);
        }
      }
      run();
    }
  }
};
variantImageAutomator();
